import type { AdapterSharedProperties } from 'owa-addins-core';
import { canModify } from 'owa-calendar-event-capabilities';
import getCalendarOwnerFromItem from 'owa-calendar-forms-common/lib/utils/getCalendarOwnerFromItem';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';

export const getSharedProperties = (event: CalendarEvent) => (): AdapterSharedProperties => {
    const owner = getCalendarOwnerFromItem(event);
    let userCanModify;

    if (!event.ItemId || !event.ItemId.Id || event.IsDraft) {
        // For unsaved items and drafts, assume the user can modify it
        userCanModify = true;
    } else {
        userCanModify = canModify(event);
    }

    // Assume that add-ins can only run on items where the user has read permissions, and
    // use the canModify function to determine if the user has edit permissions.
    return {
        owner: owner.EmailAddress,
        delegatePermissions: {
            Read: true,
            Create: userCanModify,
            EditOwn: userCanModify,
            EditAll: userCanModify,
            DeleteOwn: userCanModify,
            DeleteAll: userCanModify,
        },
    };
};
